<cs-header>
  <cs-header-title>{{header}}</cs-header-title>
</cs-header>

<cs-content>
  @if (helpId || helpTextMarkdown) {
    <cs-card-list>
      <cs-card>
        <cs-card-content>
          <cs-markdown [helpId]="helpId" [textMarkdown]="helpTextMarkdown" [(textTitle)]="header"></cs-markdown>
        </cs-card-content>
      </cs-card>
    </cs-card-list>
  }
</cs-content>